<template>
    <div>
        <ckeditor
            v-model="content"
            :editor="editor"
            :config="editorConfig"
        />
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        content: null,
        editor: ClassicEditor,
        editorConfig: {
            toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
        },
    }),
    watch: {
        content() {
            this.$emit('input', this.content);
        },
    },
    created() {
        this.content = this.value ? this.value : '';
    },
};
</script>

<style lang="postcss">
.ck.ck-toolbar,
.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
    border-color: var(--borderColor);
}
.ck.ck-toolbar__separator {
    background: var(--borderColor);
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
    border-radius: var(--borderRadius);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
    border-radius: var(--borderRadius);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.ck.ck-toolbar {
    background: var(--grey100);
}
.ck.ck-editor__main > .ck-editor__editable.ck-focused {
    box-shadow: none;
    border-color: var(--primary);
}
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on,
.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
    background: var(--grey300);
}
.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):hover {
    background: var(--grey400);
}
.ck-editor__main ul,
.ck-editor__main ol {
    list-style-position: inside;
}
.ck-editor__editable {
    height: 350px;
    @media (--smallDesktop) {
        height: 300px;
    }
    @media (--laptop) {
        height: 250px;
    }
}
</style>
